export const HOME_INSURANCE_TYPES = {
  DISABLED: 'disabled',
  GENERIC: 'generic'
}
export const HOME_INSURANCE_RISKS = {
  LOW: 'low',
  MID: 'mid',
  HIGH: 'high'
}
